/*  validation messages */
export const REQUIRED_FIELD = ' This is a required field.';
export const INVALID_EMAIL = 'Please enter a valid email address.';
export const INVALID_PASSWORD =
  'Password must be at least 8 characters long and should contain 1 uppercase, 1 lowercase, and 1 special character.';
